// Example conceptual fetch inside init or called by init
export async function fetchAndApplyTheme(apiKey: string | null) {
  if (!apiKey) return;

  try {
    console.log("[Sonaris::Theme]", apiKey)

    // const response = await fetch(`https://your-theme-api.com/themes?apiKey=${apiKey}`);
    // if (!response.ok) throw new Error('Failed to fetch theme');
    // const themeData = await response.json();

    // --- SIMULATED THEME DATA ---
    const themeData = {
      '--sonaris-color-primary': '#e11d48',
      '--sonaris-color-secondary': '#52525b',
    };
    // --- END SIMULATION ---

    applyTheme(themeData);
  } catch (error) {
    console.error('[Sonaris] Failed to load or apply dynamic theme:', error);
    // Fallback to default theme defined in CSS
  }
}

export function applyTheme(themeVariables: Record<string, string>) {
  const root = document.documentElement;
  for (const [key, value] of Object.entries(themeVariables)) {
    if (key.startsWith('--sonaris-')) { // Ensure we only set our prefixed variables
      root.style.setProperty(key, value);
    }
  }
  console.log(`[SonarisAI] Applied theme`);
}
